document.addEventListener('DOMContentLoaded', function() {
  const cartTrigger = document.getElementById('cart-trigger');
  const cartTriggerMobile = document.getElementById('cart-trigger-mobile');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');

  function openCart(e) {
    e.preventDefault();
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
    }
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', openCart);
  }

  if (cartTriggerMobile) {
    cartTriggerMobile.addEventListener('click', openCart);
  }

  if (cartClose) {
    cartClose.addEventListener('click', function() {
      cartDrawer.classList.remove('active');
      cartOverlay.classList.remove('active');
    });
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', function() {
      cartDrawer.classList.remove('active');
      cartOverlay.classList.remove('active');
    });
  }

  const quantityInputs = document.querySelectorAll('.cart-quantity-input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const line = this.getAttribute('data-line');
      const quantity = this.value;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        location.reload();
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      const nav = document.querySelector('.main-nav');
      if (nav) {
        nav.classList.toggle('active');
      }
    });
  }

  document.addEventListener('click', function(e) {
    const nav = document.querySelector('.main-nav');
    const toggle = document.getElementById('mobile-menu-toggle');
    if (nav && toggle && !nav.contains(e.target) && !toggle.contains(e.target)) {
      nav.classList.remove('active');
    }
  });
});
